/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class addressreference extends IceEntity {
  address_reference_key: string = "";
  address_key: string = "";
  address_type: IceTypes.addresstype = IceTypes.addresstype.atHome;
  status: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "ADDRESS_REFERENCE";
  }
}
